const themeDark = {
  mainColor: '#1E88E5',
  secundaryColor: '#3E3D3D',
  background1: '#252525ff',
  background2: '#2b2b2bff',
  mainTextColor: '#E0E0E0',
};

export default themeDark;
